<ideal-product-section
  xrefs
  i18n-title="@@products.xref.label"
  title="Cross References"
  navAnchorId="app.main-menu/products/details/xrefs"
  navAnchorHeading="Product"
  i18n-navAnchorHeading="@@products.nav.product.heading"
  [navAnchorHidden]="hasContent() === false"
>
  <ideal-product-cross-references #content [productId]="id()" />
</ideal-product-section>
